import { render, staticRenderFns } from "./Pos_promotion_create.vue?vue&type=template&id=ef7937a4&scoped=true&"
import script from "./Pos_promotion_create.vue?vue&type=script&lang=js&"
export * from "./Pos_promotion_create.vue?vue&type=script&lang=js&"
import style0 from "./Pos_promotion_create.vue?vue&type=style&index=0&id=ef7937a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7937a4",
  null
  
)

export default component.exports